import { useEffect, useRef, useState } from "react";
import { searchHcps } from "../axios/hcpMentions";
import type { HcpSearchResult } from "../types/hcpMention";

const SEARCH_DEBOUNCE_MS = 250;

export const useHcpMentionSearch = (query: string, enabled: boolean) => {
  const [results, setResults] = useState<HcpSearchResult[]>([]);
  const requestIdRef = useRef(0);

  useEffect(() => {
    if (!enabled) {
      requestIdRef.current += 1;
      setResults([]);
      return;
    }

    const trimmed = query.trim();
    if (!trimmed) {
      requestIdRef.current += 1;
      setResults([]);
      return;
    }

    const requestId = ++requestIdRef.current;
    const timeoutId = window.setTimeout(async () => {
      try {
        const nextResults = await searchHcps(trimmed);
        if (requestId !== requestIdRef.current) return;
        setResults(nextResults);
      } catch {
        if (requestId !== requestIdRef.current) return;
      }
    }, SEARCH_DEBOUNCE_MS);

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [query, enabled]);

  return { results };
};
